// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../contexts/AuthContext';
import { APP_VERSION } from '../config/version';
import './LoginScreen.css';

function LoginModal({ show, onClose }) {
  const { login, register } = useAuth();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isRegister) {
        await register(username, email, password);
      } else {
        await login(email, password);
      }
      // Close modal after successful login
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  return createPortal(
    <div className="login-screen">
      <div className="stars-background"></div>
      
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">STARSHIP CONSOLE</h1>
          <div className="login-subtitle">AUTHENTICATION REQUIRED</div>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {isRegister && (
            <div className="form-group">
              <label>CALLSIGN</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter callsign"
                required
                disabled={loading}
              />
            </div>
          )}

          <div className="form-group">
            <label>EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="login-error">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'AUTHENTICATING...' : (isRegister ? 'REGISTER' : 'LOGIN')}
          </button>

          <div className="login-toggle">
            {isRegister ? 'Already have access?' : 'Need access?'}
            <button
              type="button"
              onClick={() => {
                setIsRegister(!isRegister);
                setError('');
              }}
              className="toggle-button"
              disabled={loading}
            >
              {isRegister ? 'Login' : 'Register'}
            </button>
          </div>

          <div className="login-skip">
            <button
              type="button"
              onClick={handleSkip}
              className="skip-button"
              disabled={loading}
            >
              Skip Login (Play Offline)
            </button>
          </div>
        </form>

        <div className="login-version">
          v{APP_VERSION}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default LoginModal;
